module.exports = __webpack_public_path__ + "static/media/26.c8fce0de.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/style/img/monuments/brownandgray/26.jpg
// module id = 395
// module chunks = 0